import { styled } from "@mui/material/styles";

export const DigitInput = styled("input")(({ theme }) => ({
  flex: 1,
  minWidth: 0,
  height: "48px",
  textAlign: "center",
  fontSize: "20px",
  fontWeight: 600,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: "8px",
  outline: "none",
  "&:focus": {
    borderColor: theme.palette.primary.main,
    boxShadow: `0 0 0 2px ${theme.palette.primary.main}20`,
  },
  "&:disabled": {
    backgroundColor: theme.palette.action.disabledBackground,
    cursor: "not-allowed",
  },
  "&.error": {
    borderColor: theme.palette.error.main,
  },
}));
